import { PosNegEnum } from "@rmh/defs";

const toNumber = (value: unknown): number | null => {
  if (value === "" || value === null || value === undefined) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const getExamFormAnswer = (subType: string, value: unknown[]) => {
  switch (subType) {
    case "DegreesButton":
    case "TextField":
    case "SingleSelectDropdown":
      return {
        inputValueText: (value[0] ?? "") as string,
      };
    case "Percent":
    case "PercentSlider":
      return {
        inputValuePercent: toNumber(value[0]),
      };
    case "Checkbox":
    case "Radio":
      return {
        inputValueBoolean: (value[0] ?? false) as boolean,
      };
    case "NumberField":
    case "NegativePositiveSlider":
    case "RepsNumber":
      return {
        inputValueNumber: toNumber(value[0]),
      };
    case "PosNeg":
      return {
        inputValuePosNeg: (value[0] ?? PosNegEnum.Negative) as PosNegEnum,
      };
    case "YesNo":
      return {
        inputValueYesNo: (value[0] ?? false) as boolean,
      };
    case "DegreesNumber":
      return {
        inputValueDegrees: toNumber(value[0]),
      };
    case "Temperature":
      return {
        inputValueTemp: toNumber(value[0]),
      };
    case "Wfl":
      return {
        inputValueBoolean: (value[0] ?? false) as boolean,
        inputValueText: (value[1] ?? "") as string,
      };
    case "MultipleSelectDropdown":
      return {
        inputValueMultiSelect: (value[0] ?? []) as string[],
      };
    case "SecondsNumber":
      return {
        inputValueSeconds: toNumber(value[0]),
      };
    default:
      return {
        inputValueText: (value[0] ?? "") as string,
      };
  }
};
